<section>
  @if (stateType !== stateTypes.InputForm || flowOnBehalf) {
    <form class="cell" [formGroup]="form">
      <div class="grid-x">
        <div class="auto cell">
          <label>Note Type:</label>
          <select name="type" formControlName="selectedNoteType" required (change)="setNoteType($event)">
            @for (t of typeKeys; track t) {
              <option [value]="t">
                {{ types[t] }}
              </option>
            }
          </select>
          @if (form.get('selectedNoteType'); as noteType) {
            <div class="notes errors">
              @if (noteType.errors && noteType.dirty) {
                <small class="error">Note type is required</small>
              }
            </div>
          }
        </div>
      </div>
      <div class="margin-top margin-bottom">
        <label>Text:</label>
        <div name="text" formControlName="noteText" [froalaEditor]="froalaOptions"></div>
        @if (form.get('noteText'); as noteText) {
          <div class="notes errors">
            @if (noteText.errors && noteText.dirty) {
              <small class="error">Note text is required</small>
            }
          </div>
        }
      </div>
      @if (selectednoteType != noteType.Clarification) {
        <div>
          <p>
            Prior to uploading documents to notes, identify the type of document being uploaded.
            All documents will be assigned the type selected at the time they are uploaded.
            If the wrong type is assigned, delete the document, change the type, and upload it again.
            Once a note has been submitted, the type of any attached files cannot be changed.
          </p>
          <ng-select #typesSelect [items]="documentTypes" bindValue="name" bindLabel="name" [placeholder]="" formControlName="documentType"></ng-select>
        </div>
        <div class="margin-top-large margin-bottom">
          <label>Files:</label>
          <ng-template dynamic-component-loader [componentName]="'fileupload'" [componentContext]="componentContext"
          [componentData]="notesData" [formGroup]="form" (fileUploaded)="fileUploaded($event)"></ng-template>
          @if (form.get('filesValid')?.invalid) {
            <div class="notes errors">
              <small class="error">A document type must be selected when attaching a file to a note.</small>
            </div>
          }
        </div>
      }
      <div class="text-align-center margin-top">
        <span class="minor-margin-right">
          <button class="button hollow" (click)="cancel()">Cancel</button>
        </span>
        <span class="minor-margin-left">
          <button class="button" (click)="onSubmit()">
            Submit
          </button>
        </span>
      </div>
    </form>
  }

  @if (stateType !== stateTypes.InputForm || flowOnBehalf) {
    <hr>
    }

    @if (questionContext && hasNotes) {
      <section lang="en" class="cell notes">
        <notes-filter [typeKeys]="typeKeys" [userNames]="notesUsers" (onFiltering)="noteFilterChanged($event)" [shownNotes]="filteredNoteCount" [totalNotes]="totalNotes"></notes-filter>
        @if (filteredNotes.length > 0) {
          @for (note of filteredNotes; track note) {
            <div class="padding-all margin-top margin-bottom">
              <div #replyForm>
                @if (canViewNote(note)) {
                  <div class="note-group padding-all" [ngClass]="{ 'private-note': note.type < 2, 'public-note': note.type == 2, 'clarification-note': note.type === noteType.Clarification  }">
                    @if (displayExpander(note.notes)) {
                      <div class="float-left">
                        @if (!replyForm.opened) {
                          <button (click)="toggleReply(replyForm)"><svg-icon icon="icon-caret-right" class="small gray"></svg-icon></button>
                        }
                        @if (replyForm.opened) {
                          <button (click)="toggleReply(replyForm)"><svg-icon icon="icon-caret-down" class="small gray"></svg-icon></button>
                        }
                      </div>
                    }
                    <div class="notes">
                      <div class="note-header default-font">
                        <strong>{{note.createdBy}}</strong><span class="float-right">{{note.createdDate | date: 'M/d/yy | h:mma'}}</span>
                      </div>
                      <div [innerHTML]="note.text"></div>
                      <a style="display:none" href="" target="_blank" #downloadLink></a>
                      @if (isArray(note.files)) {
                        <hr />
                      }
                      @for (file of note.files; track file) {
                        <div>
                          <a (click)="downloadFile(file)">{{file.fileName}}</a>
                        </div>
                      }
                      <div class="childNotes" [ngClass]="{ 'opened': replyForm.opened }">
                        @for (childNote of note.notes; track childNote) {
                          <div>
                            <div class="note-header default-font">
                              <strong>{{childNote.createdBy}}</strong><span class="float-right">{{childNote.createdDate | date: 'M/d/yy | h:mma'}}</span>
                            </div>
                            <div [innerHTML]="childNote.text"></div>
                            @if (isArray(childNote.files)) {
                              <hr />
                            }
                            @for (file of childNote.files; track file) {
                              <div>
                                <a (click)="downloadFile(file)">{{file.fileName}}</a>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                    @if (!replyForm.isReplying) {
                      <div class="text-align-right">
                        <button (click)="openReplyForm(replyForm)">
                          <svg-icon class="cursor-pointer" icon="icon-reply"></svg-icon>
                        </button>
                      </div>
                    }
                  </div>
                }
                @if (replyForm.isReplying) {
                  <div>
                    <div class="margin-top" [(froalaModel)]="replyForm.replyText" [froalaEditor]="replyFroalaOptions"></div>
                    @if (replyForm.isDirty && !replyForm.replyText) {
                      <div class="notes errors">
                        <small class="error">Reply text is required</small>
                      </div>
                    }
                    @if (!flowOnBehalf) {
                      <ng-template dynamic-component-loader [componentName]="'fileupload'" [componentContext]="replyForm.componentContext"
                      [componentData]="replyForm.componentData" (fileUploaded)="fileUploaded($event)"></ng-template>
                    }
                    <div class="text-align-center margin-top">
                      <span class="minor-margin-right">
                        <button class="button hollow white-background" (click)="resetReplyForm(replyForm)">Cancel</button>
                      </span>
                      <span class="minor-margin-left">
                        <button class="button" (click)="reply(note, replyForm)">Add Note</button>
                      </span>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        } @else {
          <p>No notes match thte current criteria.</p>
        }
      </section>
    } @else {
      <p>You currently have no notes.</p>
    }

  </section>